import {PrerequisiteTarget} from '@/services/MockData/SalesTargets/PrerequisiteTarget';

export const usePrerequisiteTarget = () => {
  // We can use this API call in future once we decided to move with API, as of now API is not required

  // const [data, setData] = useState(null)

  // useEffect(() => {
  //   const getData = async () => {
  //     const { items } = await getPrerequisiteTarget()
  //     setData(PrerequisiteTarget.items)
  //   }
  //   getData()
  // }, [])

  return {
    prerequisiteTargetData: PrerequisiteTarget.items
  };
};
